<template>
    <div class="buttonPulse" @click="$emit('click')">
        
        {{btnContent || "Learn more"}}
        
        <div class="buttonIcon">
            <ArrowIcon :iconColour="iconColour" v-if="iconType == 'arrow'"/>
            <ArrowCircleIcon :iconColour="iconColour" v-if="iconType == 'arrowCircle'"/>
            <PlusCircleIcon :iconColour="iconColour" v-if="iconType == 'plusCircle'"/>
            <MinusCircleIcon :iconColour="iconColour" v-if="iconType == 'minusCircle'"/>
        </div>
        <PulseSpot/>
    </div>
</template>

<script>
import PulseSpot from '@/components/PulseSpot'
import ArrowIcon from '@/components/icons/ArrowIcon'
import ArrowCircleIcon from '@/components/icons/ArrowCircleIcon'
import PlusCircleIcon from '@/components/icons/PlusCircleIcon'
import MinusCircleIcon from '@/components/icons/MinusCircleIcon'

export default {
    name: 'ButtonPulse',
    props: ['btnContent', 'iconType', 'iconColour'],

    components: {
        ArrowIcon,
        ArrowCircleIcon,
        PlusCircleIcon,
        MinusCircleIcon,
        PulseSpot
    }
}
</script>

<style lang="scss" scoped>
.buttonPulse {
    background-color: $colour__accent1;
    color: $colour__primary1;
    font-size: 1.8rem;
    text-transform: uppercase;
    padding: 1.8rem 2.6rem;
    padding-right: 5.2rem;
    display: inline-block;
    position: relative;
    cursor: pointer;
}

.buttonIcon {
    position: absolute;
    height: 2rem;
    width: 2rem;
    top: 50%;
    right: 1.8rem;
    transform: translateY(-50%);
}

.spot {
    height: 2rem;
    width: 2rem;
    position: absolute;
    top: -1rem;
    right: -1rem;
}

</style>
